export enum Validation {
  ContainsSpecialCharacter = 'containsSpecialCharacter',
  InvalidEmail = 'invalidEmail',
  ContainsLowerCase = 'containsLowerCase',
  ContainsNumber = 'containsNumber',
  PasswordMinLength = 'passwordMinLength',
  ContainsUpperCase = 'containsUpperCase',
  PasswordComplexity = 'passwordComplexity',
  PasswordMatch = 'passwordMatch',
  PasswordNotMatch = 'passwordNotMatch',
  FinancesAmountMinValue = 'financesAmountMinValue',
  MaxAmount = 'maxAmount',
  EqualAmount = 'equalAmount',
  Required = 'required',
  Pattern = 'pattern',
  GreaterThan = 'greaterThan',
  DatePickerMax = 'matDatepickerMax',
  DatePickerParse = 'matDatepickerParse',
  DateNotEarlierThan = 'dateNotEarlierThan',
  MarkSubjectRules = 'markSubjectRules',
  GoogleSheets = 'googleSheet',
  DateNotLaterThan = 'dateNotLaterThan',
}
